import {
  PROGRESS_GET_REQUEST,
  PROGRESS_GET_SUCCESS,
  PROGRESS_GET_FAIL,
  PROGRESS_UPDATE_MODULE_REQUEST,
  PROGRESS_UPDATE_MODULE_SUCCESS,
  PROGRESS_UPDATE_MODULE_FAIL,
  PROGRESS_RECORD_FINAL_QUIZ_REQUEST, // <-- Import new constant
  PROGRESS_RECORD_FINAL_QUIZ_SUCCESS, // <-- Import new constant
  PROGRESS_RECORD_FINAL_QUIZ_FAIL, // <-- Import new constant
} from "../constants/quizConstants";

const initialState = {
  loading: false,
  error: null,
  progress: null,
};

export const artOfLookingProgressReducer = (state = initialState, action) => {
  switch (action.type) {
    // Request actions
    case PROGRESS_GET_REQUEST:
    case PROGRESS_UPDATE_MODULE_REQUEST:
    case PROGRESS_RECORD_FINAL_QUIZ_REQUEST: // <-- Add new constant here
      return { ...state, loading: true, error: null };

    // Success actions
    case PROGRESS_GET_SUCCESS:
    case PROGRESS_UPDATE_MODULE_SUCCESS:
    case PROGRESS_RECORD_FINAL_QUIZ_SUCCESS: // <-- Add new constant here
      return { loading: false, progress: action.payload, error: null };

    // Fail actions
    case PROGRESS_GET_FAIL:
    case PROGRESS_UPDATE_MODULE_FAIL:
    case PROGRESS_RECORD_FINAL_QUIZ_FAIL: // <-- Add new constant here
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
